import React, { useState } from 'react';
import useModalAccessibility from '../../hooks/useModalAccessibility';

const DAYS = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' }
];

const hourLabel = (h) => {
  if (h === 0) return '12:00 AM';
  if (h < 12) return `${h}:00 AM`;
  if (h === 12) return '12:00 PM';
  return `${h - 12}:00 PM`;
};

const ReportConfigModal = ({ initialConfig, onClose, onSave }) => {
  const modalRef = useModalAccessibility(onClose);
  const isEdit = Boolean(initialConfig);

  const [formData, setFormData] = useState({
    recipient_email: initialConfig?.recipient_email || '',
    day_of_week: initialConfig?.day_of_week ?? 1,
    hour: initialConfig?.hour ?? 9,
    is_active: initialConfig ? Boolean(initialConfig.is_active) : true
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (name === 'day_of_week' || name === 'hour' ? parseInt(value, 10) : value)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onSave(formData);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        ref={modalRef}
        className="edit-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="report-config-title"
      >
        <button
          type="button"
          className="modal-close"
          onClick={onClose}
          aria-label="Close dialog"
        >
          &times;
        </button>
        <h2 id="report-config-title">{isEdit ? 'Edit Report Recipient' : 'Add Report Recipient'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Recipient Email *</label>
            <input
              type="email"
              name="recipient_email"
              value={formData.recipient_email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Day of Week *</label>
            <select
              name="day_of_week"
              value={formData.day_of_week}
              onChange={handleChange}
              required
            >
              {DAYS.map(d => (
                <option key={d.value} value={d.value}>{d.label}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Hour *</label>
            <select
              name="hour"
              value={formData.hour}
              onChange={handleChange}
              required
            >
              {Array.from({ length: 24 }, (_, h) => h).map(h => (
                <option key={h} value={h}>{hourLabel(h)}</option>
              ))}
            </select>
            <span className="field-note">Server local time</span>
          </div>

          <div className="form-group">
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active}
                onChange={handleChange}
              />
              <span>Active</span>
            </label>
            <span className="field-note">When inactive, this recipient is skipped by the scheduler.</span>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn-save" disabled={loading}>
              {loading ? 'Saving...' : (isEdit ? 'Save Changes' : 'Add Recipient')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportConfigModal;
